import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';
import { statusOptions } from '../data/mockData';
import './AddProjectForm.css';

const AddProjectForm = ({ onAddProject, onCancel, clients, loading }) => {
  const [formData, setFormData] = useState({
    projectName: '',
    jobNumber: '',
    clientId: '',
    modelingStatus: 'Startup',
    billingStatus: 'Quoted',
    agreementStatus: 'Not Signed',
    dueDate: '',
    location: '',
    modelPrice: '',
    approximateAcreage: '',
    isHighPriority: false
  });

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({
      ...formData,
      [e.target.name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.projectName && formData.jobNumber && formData.dueDate && formData.clientId) {
      onAddProject(formData);
      setFormData({
        projectName: '',
        jobNumber: '',
        clientId: '',
        modelingStatus: 'Startup',
        billingStatus: 'Quoted',
        agreementStatus: 'Not Signed',
        dueDate: '',
        location: '',
        modelPrice: '',
        approximateAcreage: '',
        isHighPriority: false
      });
    }
  };

  return (
    <div className="add-project-overlay">
      <div className="add-project-form">
        <div className="form-header">
          <h3>Add New Project</h3>
          <button onClick={onCancel} className="close-btn">
            <X size={20} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="projectName">Project Name *</label>
              <input
                type="text"
                id="projectName"
                name="projectName"
                value={formData.projectName}
                onChange={handleChange}
                required
                placeholder="Enter project name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="jobNumber">Job Number *</label>
              <input
                type="text"
                id="jobNumber"
                name="jobNumber"
                value={formData.jobNumber}
                onChange={handleChange}
                required
                placeholder="Enter job number"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="clientId">Client *</label>
              <select
                id="clientId"
                name="clientId"
                value={formData.clientId}
                onChange={handleChange}
                required
              >
                <option value="">Select a client</option>
                {clients.map(client => (
                  <option key={client.id} value={client.id}>{client.name}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="location">Location</label>
              <input
                type="text"
                id="location"
                name="location"
                value={formData.location}
                onChange={handleChange}
                placeholder="Enter project location"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="modelingStatus">Modeling Status</label>
              <select
                id="modelingStatus"
                name="modelingStatus"
                value={formData.modelingStatus}
                onChange={handleChange}
              >
                {statusOptions.modelingStatus.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="billingStatus">Billing Status</label>
              <select
                id="billingStatus"
                name="billingStatus"
                value={formData.billingStatus}
                onChange={handleChange}
              >
                {statusOptions.billingStatus.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="agreementStatus">Agreement Status</label>
            <select
              id="agreementStatus"
              name="agreementStatus"
              value={formData.agreementStatus}
              onChange={handleChange}
            >
              {statusOptions.agreementStatus.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="dueDate">Due Date *</label>
              <input
                type="date"
                id="dueDate"
                name="dueDate"
                value={formData.dueDate}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="modelPrice">Model Price ($)</label>
              <input
                type="number"
                id="modelPrice"
                name="modelPrice"
                value={formData.modelPrice}
                onChange={handleChange}
                placeholder="Enter model price"
                min="0"
                step="0.01"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="approximateAcreage">Approximate Acreage</label>
              <input
                type="number"
                id="approximateAcreage"
                name="approximateAcreage"
                value={formData.approximateAcreage}
                onChange={handleChange}
                placeholder="Enter acreage"
                min="0"
                step="0.1"
              />
            </div>

            <div className="form-group">
              <div className="checkbox-group">
                <input
                  type="checkbox"
                  id="isHighPriority"
                  name="isHighPriority"
                  checked={formData.isHighPriority}
                  onChange={handleChange}
                />
                <label htmlFor="isHighPriority">High Priority Project</label>
              </div>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" onClick={onCancel} className="cancel-button" disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="submit-button" disabled={loading}>
              <Plus size={16} />
              {loading ? 'Adding Project...' : 'Add Project'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddProjectForm;